const styles = {
    tryAgain: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: '16px',
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
        width: '50%',
    },
    exit: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: '16px',
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderColor: '#3876AA',
        borderWidth: '2px',
        width: '50%',
    },
    errorRows: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#5C697B',
    },
    errorsDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    popupButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '24px',
    },
    email: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#5C697B',
    },
    view: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: '16px',
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#178900',
        width: '100%',
    },
    duplicatePopupButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
};
export default styles;
